<template>
  <div class="row">
    <div class="col-6 reports-select" v-for="ty in promotions" v-on:click="setType(ty.id)">
      <router-link :to="{}" :class="(stype == ty.id) ? 'active' : ''" class="element-box el-tablo">
        {{ ty.title }}
        <span class="aci">
					<i class="icon-check"></i>
				</span>
      </router-link>
    </div>
    <div class="col-12">

      <div v-if="status > 0">
        <div class="alert alert-danger" v-if="status == 403">
          {{ t.error.access_denied_content }}
        </div>
        <div class="alert alert-danger" v-if="status == 404">
          {{ t.error.notfound_content_list }}
        </div>
      </div>

      <div class="alert alert-success" v-if="Msg">{{ Msg }}</div>
      <div class="alert alert-danger" v-if="errorMsg">{{ errorMsg }}</div>
      <filterGenerator :filter="filter" v-if="stype > 0"></filterGenerator>
    </div>

    <div class="col-12" v-if="result">
      <div class="mt-4">
        <p class="text-right">{{ result.totalBonusEarnings }} / {{ result.target }}</p>
        <div class="progress">
          <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar bg-success" :style="{width: result.targetRemainingPercent+'%'}">
            {{ result.targetRemainingPercent+'%' }}</div>
        </div>
      </div>

      <table class="table table-bordered table-lg table-v2 table-striped mt-4">
        <thead>
        <tr>
          <th>Datetime</th>
          <th>Waiting</th>
          <th>Won</th>
          <th>Loss</th>
          <th>Cancelled</th>
          <th>Refund</th>
          <th>Total Amount</th>
        </tr>
        </thead>
        <tbody>

        <template v-for="r in result.result.report">
          <tr class="text-center" v-if="r.day && r.month && r.year">
            <td>{{ r.day }}.{{ r.month }}.{{ r.year }}</td>
            <td>{{ r.waiting_amount}} ({{ r.waiting }})</td>
            <td>{{ r.won_amount}} ({{ r.won }})</td>
            <td>{{ r.loss_amount}} ({{ r.loss }})</td>
            <td>{{ r.cancelled_amount}} ({{ r.cancelled }})</td>
            <td>{{ r.refund_amount}} ({{ r.refund }})</td>
            <td class="text-right"><strong>{{ r.amount }}</strong></td>
          </tr>
          <tr class="text-center" v-if="r.month && r.year">
            <td>{{ r.month }}.{{ r.year }}</td>
            <td>{{ r.waiting_amount}} ({{ r.waiting }})</td>
            <td>{{ r.won_amount}} ({{ r.won }})</td>
            <td>{{ r.loss_amount}} ({{ r.loss }})</td>
            <td>{{ r.cancelled_amount}} ({{ r.cancelled }})</td>
            <td>{{ r.refund_amount}} ({{ r.refund }})</td>
            <td class="text-right"><strong>{{ r.amount }}</strong></td>
          </tr>
          <tr class="text-center text-primary" v-if="!r.day &&!r.month && r.year">
            <td>{{ r.year }}</td>
            <td>{{ r.waiting_amount}} ({{ r.waiting }})</td>
            <td>{{ r.won_amount}} ({{ r.won }})</td>
            <td>{{ r.loss_amount}} ({{ r.loss }})</td>
            <td>{{ r.cancelled_amount}} ({{ r.cancelled }})</td>
            <td>{{ r.refund_amount}} ({{ r.refund }})</td>
            <td class="text-right"><strong>{{ r.amount }}</strong></td>
          </tr>
        </template>

        </tbody>
      </table>

      <router-link v-if="filter.model.user" :to="{ name: 'bets', query: {promotions: promotion.id, uid: filter.model.user} }">
        Show all bet coupons related about the promotion.
      </router-link>
    </div>
  </div>
</template>

<script>
    import filterGenerator from '@/components/form/filter'

    export default {
        name: "bonusCalculatorForm",
        components: { filterGenerator },
        data () {
            return {
                result: null,
                t: this.$root.t,
                promotions: null,
                promotion: null,
                type: null,
                filter: null,
                e: false,
                currencies: [],
                results: [],
                errorMsg: null,
                Msg: null,
                stype: 0,
                status: 0

            }
        },
        watch: {
            'stype' () {
                this.filter.model.promotion = this.stype;
            }
        },
        mounted () {
            this.setFilter();
            this.fetchPromotions();
        },
        methods: {
            setType (t) {
                this.stype = t;
                this.filter.model.promotion = t;
                this.fetchPromotion(t);
            },
            filterNow: function() {
                var model = this.$route.query;
                this.$router.push({ query: {} });
                this.$router.push({ query: this.filter.model });
                window.scrollTo(0,0);
            },
            setFilter () {
                this.filter = {
                    model: {
                        uid: '',
                        minBetOdd: (this.promotion) ? this.promotion.min_odd_per_bet : 0,
                        maxBetOdd: (this.promotion) ? this.promotion.max_odd_per_bet : 0,
                        multiplier: (this.promotion) ? this.promotion.multiplier : 0,
                        timeRange: [],
                        errorMsg: null,
                        promotion: (this.promotion) ? this.promotion.id : 0,
                    },
                    schema: {
                        groups: [
                            {
                                legend: this.t.filter.title,
                                fields: [
                                    {
                                        type: "input",
                                        inputType: "number",
                                        label: this.t.promo_sent_bonus,
                                        model: "bonus",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "input",
                                        inputType: "number",
                                        label: this.t.min_bet_odd_per_event,
                                        model: "minBetOdd",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "input",
                                        inputType: "number",
                                        label: this.t.max_bet_odd_per_event,
                                        model: "maxBetOdd",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "input",
                                        inputType: "number",
                                        label: this.t.promo_multiplier,
                                        model: "multiplier",
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "Datepicker",
                                        class: 'test',
                                        label: this.t.time_range,
                                        model: "timeRange",
                                        readonly: false,
                                        featured: false,
                                        disabled: false,
                                        options: {
                                            not_before: null,
                                            clearable: true,
                                            range: true,
                                            firstDay: 1,
                                            format: 'YYYY-MM-DD',
                                            dataFormat: 'YYYY-MM-DD',
                                        }
                                    },
                                    {
                                        type: "switch",
                                        label: this.t.show_days,
                                        model: "showDays",
                                        readonly: false,
                                        featured: false,
                                        disabled: false,
                                        default: false
                                    },
                                    {
                                        type: "User",
                                        inputType: "text",
                                        label: this.t.users,
                                        model: "user",
                                        multi: false,
                                        readonly: false,
                                        featured: false,
                                        disabled: false
                                    },
                                    {
                                        type: "submit",
                                        label: "",
                                        buttonText: this.t.create_report,
                                        onSubmit: this.createReport,
                                        validateBeforeSubmit: false,
                                    }
                                ]
                            }
                        ],
                    },
                    options: {
                        validateAfterLoad: true,
                        validateAfterChanged: true
                    }
                }
            },
            async fetchPromotions () {
                this.$http.get(api+'api/v1/promotions?noCache=1').then(response => {
                    // get body data
                    this.promotions = response.body.promotions;

                    }, response => {
                })
            },
            async fetchPromotion (id) {
                this.$http.get(api+'api/v1/promotion/'+id).then(response => {
                    // get body data
                    this.promotion = response.body.result.detail;

                    this.setFilter();

                }, response => {
                })
            },
            async createReport () {
                this.$http.post(api+'api/v1/bonus-calculator', this.filter.model).then(response => {

                    this.Msg = response.body.msg;
                    this.result = response.body;
                }, response => {
                    this.errorMsg = response.body.error;
                    this.status = response.status;
                })

                setTimeout(()   => {
                    this.Msg = null;
                    this.errorMsg = null;
                }, 3500);
            },
            selectedReportClass: function (t) {
                return (this.stype == t) ? 'active' : '';
            }
        }
    }
</script>

<style scoped>
  .reports-select a {
    display: relative !important;
  }
  .reports-select .aci{
    display: none;
    float: right;
    color: #4efd4e;
    font-size: 29px;
    padding-right: 20px;
  }
  .reports-select .active .aci{
    display: block
  }
</style>



// WEBPACK FOOTER //
// src/components/reports/form/bonusCalculatorForm.vue